<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th jhiSortBy="name">
          <span jhiTranslate="transporterMember.service">First Name</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="isApplicableAsSales">
          <span jhiTranslate="transporterMember.commercialTeam">isApplicableAsSales</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let transporterGroup of transporterGroups; trackBy: trackId">
        <td>
          <span class="no-capitalize">{{ transporterGroup.name }}</span>
        </td>
        <td>
          <span class="no-capitalize">{{ transporterGroup.isApplicableAsSales! | transformBooleanToYesOrNo }}</span>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <jhi-bary-button
              class="mr-3"
              [tooltip]="'BTN.EDIT' | translate"
              [routerLink]="PATHS.MIDDLE_COMMERCIAL_SERVICE_ID_EDIT.withId(transporterGroup.id)"
              icon="pencil-alt"
              size="sm"
              color="primary"
              [rounded]="true"
              [floating]="true"
              [outline]="true"
            >
            </jhi-bary-button>
            <jhi-bary-button [tooltip]="'BTN.DELETE' | translate" (clickEvent)="delete(transporterGroup)" icon="times" size="sm" color="primary" [rounded]="true" [floating]="true">
            </jhi-bary-button>
          </div>
        </td>
      </tr>
      <tr [hidden]="transporterGroups && transporterGroups.length > 0" class="text-center">
        <td colspan="7" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="LABEL.NO_RESULT">No services</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
